// mulberry32 : PRNG seedé, état = entier 32 bits porté par GameState.rngState.
// rngNext fait avancer rngState en place (déterminisme total, aucun RNG global).
export function rngNext(s: { rngState: number }): number {
  s.rngState = (s.rngState + 0x6D2B79F5) | 0
  let t = s.rngState
  t = Math.imul(t ^ (t >>> 15), t | 1)
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61)
  return (t ^ (t >>> 14)) >>> 0
}
// n <= 0 : renvoie 0 mais consomme QUAND MÊME un tirage (déterminisme : le nombre de
// tirages ne doit jamais dépendre d'un garde-fou).
export function rngInt(s: { rngState: number }, n: number): number {
  const v = rngNext(s)
  return n > 0 ? v % n : 0
}

// Départage d'égalité SEEDÉ (Tâche 3.4) : parmi des ex aequo (indices en ordre CROISSANT pour
// un déterminisme stable), tire un vainqueur au sort déterministe (rngInt sur s.rngState).
// ⚠️ Consomme UN tirage : à n'appeler QU'À la résolution FINALE de la victoire (≥ 2 candidats),
// jamais en cours de partie — sinon la séquence RNG des spawns/moines/événements se décale.
export function tieBreakWinner(s: { rngState: number }, candidates: number[]): number {
  return candidates[rngInt(s, candidates.length)]!
}
